import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

const Media = () => {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);

  const load = () => api.get("/media").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("name", file.name);
      await api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Yüklendi");
      load();
    } catch { toast.error("Yüklenemedi"); }
    finally { setUploading(false); e.target.value = ""; }
  };

  const del = async (id) => {
    await api.delete(`/media/${id}`); load();
  };

  return (
    <div className="space-y-6" data-testid="media-page">
      <header className="flex items-end justify-between">
        <div>
          <h1 className="font-serif text-3xl text-zbeach-dark">Görsel Galerisi</h1>
          <p className="text-zbeach-muted text-sm mt-1">Site ve ürün görsellerini yönetin.</p>
        </div>
        <label className="px-4 py-2.5 rounded-full bg-zbeach-turquoise text-white font-medium text-sm cursor-pointer btn-glow" data-testid="media-upload">
          {uploading ? "Yükleniyor..." : <><i className="fa-solid fa-upload mr-1" /> Görsel Yükle</>}
          <input type="file" accept="image/*" onChange={upload} className="hidden" />
        </label>
      </header>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {items.map((it) => (
          <div key={it.id} className="relative group rounded-xl overflow-hidden bg-zbeach-sand aspect-square">
            <img src={it.url} alt={it.altText || it.name} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition flex items-end justify-between p-2 opacity-0 group-hover:opacity-100">
              <div className="text-white text-[10px] truncate">{it.name}</div>
              <button onClick={() => del(it.id)} className="w-7 h-7 rounded-full bg-red-600 text-white"><i className="fa-solid fa-trash text-xs" /></button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center text-zbeach-muted text-sm py-12">Henüz görsel yüklenmemiş.</div>}
      </div>
    </div>
  );
};

export default Media;
